export default __webpack_public_path__ + "static/media/app-home-dark.dd5c433b.png";